import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { FinantialReceiptsReportService } from "src/app/shared/services/finantial-receipts-report.service";
import { finantialReceiptsReportActions } from "./finantial-receipts-report.actions";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class FinantialReceiptsReportEffects {

    constructor(
        private service: FinantialReceiptsReportService,
        private action$: Actions,
        private notify: NotifyService
    ) { }

    loadFinantialReceiptsReport$ = createEffect(() =>
        this.action$.pipe(
            ofType(finantialReceiptsReportActions.loadFinantialReceiptsReport),
            exhaustMap(() =>
                this.service
                    .get()
                    .pipe(
                        map((res) => finantialReceiptsReportActions.loadFinantialReceiptsReportSuccess({ finantial_receipts_report: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    )
            )
        )
    )

}